import AddIcon from '@mui/icons-material/Add';
import BoltIcon from '@mui/icons-material/Bolt';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SettingsIcon from '@mui/icons-material/Settings';

import { can, featureEnabled, strictFeatureEnabled } from '../../../utils/access';

/**
 * Palette actions. `perm` / `featureKey` are the same values the matching <Route>
 * guards in App.js use, evaluated through the same predicates (utils/access.js).
 * `path` navigates; `dialog` opens one of the dialogs mounted by CommandPaletteHost.
 */
export const PALETTE_ACTIONS = [
  { key: 'new_work_order', labelKey: 'commandPalette.actions.newWorkOrder', icon: AddIcon, perm: 'work_orders.create', dialog: 'work_order' },
  {
    key: 'quote_machine',
    labelKey: 'commandPalette.actions.quoteMachine',
    icon: BoltIcon,
    perm: 'work_orders.create',
    featureKey: 'quote_machine_enabled',
    dialog: 'quote_machine',
  },
  { key: 'new_customer', labelKey: 'commandPalette.actions.newCustomer', icon: PersonAddIcon, perm: 'customers.manage', dialog: 'customer' },
  { key: 'open_calendar', labelKey: 'commandPalette.actions.openCalendar', icon: CalendarMonthIcon, perm: 'work_orders.view', path: '/calendar' },
  { key: 'open_work_orders', labelKey: 'commandPalette.actions.openWorkOrders', icon: DirectionsCarIcon, perm: 'work_orders.view', path: '/maintenances' },
  { key: 'new_invoice', labelKey: 'commandPalette.actions.newInvoice', icon: ReceiptIcon, perm: 'invoices.manage', dialog: 'invoice' },
  {
    key: 'open_counter_sale',
    labelKey: 'commandPalette.actions.openCounterSale',
    icon: PointOfSaleIcon,
    perm: 'parts_sales.manage',
    featureKey: 'counter_sales_available',
    path: '/kassamyynti',
  },
  {
    key: 'open_purchase_invoices',
    labelKey: 'commandPalette.actions.openPurchaseInvoices',
    icon: ReceiptLongIcon,
    perm: 'menu.purchase_invoices',
    strictFeatureKey: 'purchase_ledger_available',
    path: '/ostolaskut',
  },
  { key: 'open_settings', labelKey: 'commandPalette.actions.openSettings', icon: SettingsIcon, perm: null, path: '/settings' },
];

export function availableActions(currentOrganization) {
  return PALETTE_ACTIONS.filter(
    (action) =>
      can(currentOrganization, action.perm) &&
      featureEnabled(currentOrganization, action.featureKey) &&
      strictFeatureEnabled(currentOrganization, action.strictFeatureKey)
  );
}

/** Substring match on the translated label; an empty query keeps every action. */
export function filterActions(actions, query, t) {
  const needle = query.trim().toLowerCase();
  if (!needle) return actions;
  return actions.filter((action) => t(action.labelKey).toLowerCase().includes(needle));
}
